import React, { useState } from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";

const main = assetUrl("../../styles/main.css");

const AccordionItem = ({ title = "", headers = [], data = [] }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="payments_accordion_container">
      {title && (
        <div className="">
          <div
            className="payments_accordion_header"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div>
              <h5>{title}</h5>
            </div>
            {isOpen ? (
              <span>
                <svg
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 9V5.20001L6 0.600006L0 5.20001V9L6 4.39999L12 9Z"
                    fill="black"
                  />
                </svg>
              </span>
            ) : (
              <span>
                <svg
                  width="12"
                  height="9"
                  viewBox="0 0 12 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: "rotate(180deg)" }}
                >
                  <path
                    d="M12 9V5.20001L6 0.600006L0 5.20001V9L6 4.39999L12 9Z"
                    fill="black"
                  />
                </svg>
              </span>
            )}
          </div>
          {isOpen && (
            <div className="accordion_content">
              {headers.map((header, index) => (
                <div key={index} className="payments_gap-15 accordion-padding">
                  <div>{header}</div>
                  <div>{data[index]}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const PaymentsAccordion = ({ title = "", headers = [], data = [] }) => {
  return (
    <div>
      <Helmet>
        <link rel="stylesheet" href={main} />
      </Helmet>

      <AccordionItem headers={headers} data={data} title={title} />
    </div>
  );
};

export default PaymentsAccordion;
